var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.showDetail
    ? _c(
        "div",
        {
          staticStyle: {
            height: "100%",
            display: "flex",
            "flex-direction": "column"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "cargo-advance-search bpm-approval-process",
              staticStyle: {
                width: "100%",
                "margin-top": "5px",
                "min-width": "1280px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "section" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { "label-position": "left", "label-width": "85px" }
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-bottom": "5px" },
                          attrs: { gutter: 10 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.toQuery }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Query")) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "button_bpm_create"
                                      ]),
                                      expression:
                                        "$checkPermission(['button_bpm_create'])"
                                    }
                                  ],
                                  attrs: { type: "primary" },
                                  on: { click: _vm.toCreateProcess }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_CreateProcess")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "button_bpm_edit"
                                      ]),
                                      expression:
                                        "$checkPermission(['button_bpm_edit'])"
                                    }
                                  ],
                                  attrs: { type: "primary" },
                                  on: { click: _vm.toEditProcess }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_EditProcess")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "button_bpm_copy"
                                      ]),
                                      expression:
                                        "$checkPermission(['button_bpm_copy'])"
                                    }
                                  ],
                                  attrs: { type: "primary" },
                                  on: { click: _vm.toCopyProcess }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_CopyProcess")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "button_bpm_create"
                                      ]),
                                      expression:
                                        "$checkPermission(['button_bpm_create'])"
                                    }
                                  ],
                                  attrs: { type: "primary" },
                                  on: { click: _vm.toAppoint }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Appoint2")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "auto-width",
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_ProcessName"),
                                    prop: "processName"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        filterable: "",
                                        "allow-create": ""
                                      },
                                      model: {
                                        value: _vm.filter.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "name", $$v)
                                        },
                                        expression: "filter.name"
                                      }
                                    },
                                    _vm._l(_vm.workflowGroupNameList, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.name,
                                          value: item.name
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_FormName")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      "tag-value": "code",
                                      "static-options": _vm.workflowTypes
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.filter.documentConfigId = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ApplicationBranch1"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Office,
                                      multiple: "",
                                      clearable: "",
                                      filterable: "",
                                      "default-multiple-value":
                                        _vm.filter.officeIdList
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.filter.officeIdList = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "auto-width",
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_WhetherItIsEnabled"
                                    ),
                                    prop: "initiateBranchCompany"
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      "static-options": _vm.yesOrNotList,
                                      clearable: "",
                                      "tag-value": "code"
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.filter.enabled = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("div", { staticClass: "grid-view approval-list-grid" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "config-module": "261601",
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      rowDataChanged: _vm.rowDataChanged
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "261601",
                    total: _vm.filter.total,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ]),
          _vm.appointDialog.visible
            ? _c("appoint-dialog", {
                attrs: {
                  visible: _vm.appointDialog.visible,
                  appoints: _vm.appoints
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.appointDialog, "visible", $event)
                  },
                  change: _vm.doAppoint,
                  close: function($event) {
                    _vm.appointDialog.visible = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "bpm-approval-process app-main-content",
          staticStyle: { height: "100%" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "28px",
                "margin-left": "16px",
                "margin-top": "16px"
              }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.onSave()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "default" },
                  on: {
                    click: function($event) {
                      return _vm.onCancel()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          ),
          _c(
            "cargo-left-right-resize",
            {
              ref: "cargoLeftRightResize",
              staticStyle: {
                "min-height": "90%",
                border: "1px solid",
                margin: "16px"
              },
              attrs: {
                "left-style": {
                  flex: "none",
                  "max-width": "271px",
                  "min-width": "271px"
                }
              }
            },
            [
              _c("template", { slot: "left" }, [
                _c(
                  "div",
                  { staticClass: "tabs-container section" },
                  [
                    _c(
                      "el-tabs",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { type: "card" },
                        model: {
                          value: _vm.activeTab,
                          callback: function($$v) {
                            _vm.activeTab = $$v
                          },
                          expression: "activeTab"
                        }
                      },
                      [
                        _c(
                          "el-tab-pane",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.activity"),
                              name: "activity"
                            }
                          },
                          [
                            _c(
                              "el-form",
                              {
                                staticStyle: { margin: "10px" },
                                attrs: {
                                  "label-position": "top",
                                  "label-width": "200px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_ProcessName"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.form.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "name", $$v)
                                        },
                                        expression: "form.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_ApplicationBranch1"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames.basic_data_Office,
                                        multiple: "",
                                        clearable: "",
                                        filterable: "",
                                        "default-multiple-value":
                                          _vm.form.officeIds
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.officeIds = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_RevertProcess"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "tag-value": "code",
                                        "static-options":
                                          _vm.revocationProcessStatus,
                                        "default-value": _vm.form.canUndo
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.canUndo = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_BindForm"),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "tag-value": "code",
                                        "static-options": _vm.formDropList,
                                        "default-value":
                                          _vm.form.documentConfigId
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.documentConfigId = p.value
                                          _vm.documentConfigIdChange(p)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm.showInvoicingMode
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_InvoicingMode"
                                          ),
                                          required: ""
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          attrs: {
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.formSubtypeList,
                                            "default-value":
                                              _vm.form.formSubtype
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.form.formSubtype = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.form.documentConfigId ===
                                _vm.WorkflowConstants.BILL_PAYMENT.code
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_AutoWriteOffAfterApproval"
                                          ),
                                          required: ""
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          attrs: {
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.verificationList,
                                            "default-value":
                                              _vm.form.autoWriteOffAfterApproval
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.form.autoWriteOffAfterApproval =
                                                p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_UnknownProcessProcessing"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "tag-value": "code",
                                        "static-options":
                                          _vm.unknownProcessHandle,
                                        "default-value":
                                          _vm.form.unknownProcessHandleMode
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.unknownProcessHandleMode =
                                            p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_QuickApprovalMode"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "tag-value": "code",
                                        "static-options":
                                          _vm.quickApprovalModes,
                                        "default-value":
                                          _vm.form.quickApprovalMode
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.quickApprovalMode = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_MessageNotificationMethod"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value: _vm.form.msgNotifyEmail,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "msgNotifyEmail",
                                              $$v
                                            )
                                          },
                                          expression: "form.msgNotifyEmail"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Viewer.email")))]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value: _vm.form.msgNotifyBell,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "msgNotifyBell",
                                              $$v
                                            )
                                          },
                                          expression: "form.msgNotifyBell"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("CargoMsg.Cargo_Bell"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value:
                                            _vm.form.msgNotifyEnterpriseWechat,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "msgNotifyEnterpriseWechat",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.msgNotifyEnterpriseWechat"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_EnterpriseWechat"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_Template_Push"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "space-between",
                                          "flex-wrap": "wrap"
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "49%" },
                                          attrs: {
                                            "tag-name": "name",
                                            "tag-value": "uuid",
                                            "static-options": _vm.templateList,
                                            "default-value":
                                              _vm.form.templateUuid,
                                            filterable: "",
                                            "filter-tag-names": ["name"],
                                            "filter-type": "global"
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.form.templateUuid = p.value
                                            }
                                          }
                                        }),
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "49%" },
                                          attrs: {
                                            "tag-name": "chineseName",
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.exportTypeList,
                                            "default-value": _vm.form.exportType
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.form.exportType = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { height: "120px" },
                                    attrs: {
                                      label: _vm.$t("SeaExport.Remarks")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea" },
                                      model: {
                                        value: _vm.form.remark,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "remark", $$v)
                                        },
                                        expression: "form.remark"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          {
                            attrs: { label: _vm.$t("Menu.Node"), name: "node" }
                          },
                          [
                            _c(
                              "el-form",
                              {
                                class:
                                  _vm.chooseIndex === null ? "no-click" : "",
                                staticStyle: { margin: "10px" },
                                attrs: {
                                  disabled: _vm.chooseIndex === null,
                                  "label-position": "top",
                                  "label-width": "200px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Sop.nodeName"),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.node.nodeName,
                                        callback: function($$v) {
                                          _vm.$set(_vm.node, "nodeName", $$v)
                                        },
                                        expression: "node.nodeName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { height: "120px" },
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_ApproverSource"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        staticStyle: { display: "grid" },
                                        on: {
                                          change: function(val) {
                                            return (_vm.node.actorType = val)
                                          }
                                        },
                                        model: {
                                          value: _vm.node.actorType,
                                          callback: function($$v) {
                                            _vm.$set(_vm.node, "actorType", $$v)
                                          },
                                          expression: "node.actorType"
                                        }
                                      },
                                      _vm._l(_vm.actorTypes, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: { display: "flex" }
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: { label: item.code },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.chooseActorType(
                                                      item.code
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.isZh
                                                      ? item.chineseName
                                                      : item.englishName
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: item.tips,
                                                  expression: "item.tips"
                                                }
                                              ],
                                              staticClass:
                                                "el-icon-question tips",
                                              attrs: { title: item.tips }
                                            })
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { height: "120px" },
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_NotifierSource"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        staticStyle: { display: "grid" },
                                        on: {
                                          change: function(val) {
                                            return (_vm.node.notifierType = val)
                                          }
                                        },
                                        model: {
                                          value: _vm.node.notifierType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.node,
                                              "notifierType",
                                              $$v
                                            )
                                          },
                                          expression: "node.notifierType"
                                        }
                                      },
                                      _vm._l(_vm.notifierTypes, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: { display: "flex" }
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: { label: item.code },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.chooseNotifierType(
                                                      item.code
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.isZh
                                                      ? item.chineseName
                                                      : item.englishName
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: item.tips,
                                                  expression: "item.tips"
                                                }
                                              ],
                                              staticClass:
                                                "el-icon-question tips",
                                              attrs: { title: item.tips }
                                            })
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                ),
                                _vm.form.documentConfigId ===
                                _vm.WorkflowConstants.BILL_PAYMENT.code
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_PreconditionsForApproval"
                                          ),
                                          required: ""
                                        }
                                      },
                                      [
                                        _vm._l(
                                          _vm.node.preCriteriaList,
                                          function(condition, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                key: index,
                                                staticStyle: {
                                                  "margin-top": "10px"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        on: {
                                                          change: function(p) {
                                                            _vm.preCriteriaChangeHandle(
                                                              p
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            condition.criteria,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              condition,
                                                              "criteria",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "condition.criteria"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.preCriteriaOptions,
                                                        function(item, index) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: index,
                                                              attrs: {
                                                                label:
                                                                  _vm.$store
                                                                    .getters
                                                                    .language ===
                                                                  "zh"
                                                                    ? item.chineseName
                                                                    : item.englishName,
                                                                value:
                                                                  item.code,
                                                                disabled:
                                                                  item.disable
                                                              }
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 4 } },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        attrs: { disabled: "" },
                                                        model: {
                                                          value:
                                                            condition.operator,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              condition,
                                                              "operator",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "condition.operator"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "=",
                                                            value: "="
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 6 } },
                                                  [
                                                    _c("el-input", {
                                                      model: {
                                                        value:
                                                          condition.checkValue,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            condition,
                                                            "checkValue",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "condition.checkValue"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "2px",
                                                      "margin-bottom": "2px",
                                                      "text-align": "right"
                                                    },
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "criteria-remove",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeCriteria(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v(" - ")]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 8 } },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        model: {
                                                          value:
                                                            condition.relation,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              condition,
                                                              "relation",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "condition.relation"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "AND",
                                                            value: 1
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        _c(
                                          "el-row",
                                          [
                                            _c(
                                              "el-col",
                                              {
                                                staticStyle: {
                                                  "margin-top": "2px"
                                                },
                                                attrs: { span: 8 }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "criteria-add",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addCriteria()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" + ")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_ApproverExecutionMode"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        staticStyle: { display: "grid" },
                                        on: {
                                          change: function(val) {
                                            return (_vm.node.nodeType = val)
                                          }
                                        },
                                        model: {
                                          value: _vm.node.nodeType,
                                          callback: function($$v) {
                                            _vm.$set(_vm.node, "nodeType", $$v)
                                          },
                                          expression: "node.nodeType"
                                        }
                                      },
                                      _vm._l(_vm.nodeTypes, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: { display: "flex" }
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: item.code } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.isZh
                                                      ? item.chineseName
                                                      : item.englishName
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: item.tips,
                                                  expression: "item.tips"
                                                }
                                              ],
                                              staticClass:
                                                "el-icon-question tips",
                                              attrs: { title: item.tips }
                                            })
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_RejectMethod"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value: _vm.node.cancelAllowed,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.node,
                                              "cancelAllowed",
                                              $$v
                                            )
                                          },
                                          expression: "node.cancelAllowed"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_AllowDirectReturnToInitiator"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "BusinessIntelligence.businessIntelligenceDashboard.biDashboard"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "BusinessIntelligence.businessIntelligenceDashboard.dashboardName"
                                        )
                                      },
                                      model: {
                                        value: _vm.node.dashboardName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.node,
                                            "dashboardName",
                                            $$v
                                          )
                                        },
                                        expression: "node.dashboardName"
                                      }
                                    }),
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "BusinessIntelligence.businessIntelligenceDashboard.dashboardId"
                                        )
                                      },
                                      model: {
                                        value: _vm.node.dashboardId,
                                        callback: function($$v) {
                                          _vm.$set(_vm.node, "dashboardId", $$v)
                                        },
                                        expression: "node.dashboardId"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("template", { slot: "right" }, [
                _c(
                  "div",
                  {
                    staticClass: "col",
                    staticStyle: {
                      width: "99%",
                      height: "96%",
                      overflow: "auto",
                      display: "flex",
                      "flex-direction": "column",
                      "background-color": "white",
                      margin: "12px 12px 12px 6px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "100%", height: "100%" } },
                      [
                        _c(
                          "draggable",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "", animation: "300" },
                            on: { sort: _vm.sort },
                            model: {
                              value: _vm.form.workflows,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "workflows", $$v)
                              },
                              expression: "form.workflows"
                            }
                          },
                          [
                            _c(
                              "transition-group",
                              { staticStyle: { width: "100%" } },
                              _vm._l(_vm.form.workflows, function(
                                item,
                                workflowIndex
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: item.priority,
                                    staticClass: "item",
                                    attrs: {
                                      title: _vm.rulesLabelName(item, true)
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              height: "36px",
                                              "background-color":
                                                "rgba(244, 249, 255)",
                                              display: "flex"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                "align-self": "center",
                                                "margin-left": "5px",
                                                width: "11px",
                                                height: "11px"
                                              },
                                              attrs: { src: "/static/move.svg" }
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "align-self": "center",
                                                  "margin-left": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Priority"
                                                    ) +
                                                      (workflowIndex + 1)
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "align-self": "center",
                                                  "margin-left": "40px",
                                                  color: "rgba(65, 141, 220)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onConfiguration(
                                                      workflowIndex
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_TriggerConditions"
                                                    ) +
                                                      ": " +
                                                      _vm.getTriggerConditionsLabel(
                                                        item.workflowRuleMode
                                                      )
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "align-self": "center",
                                                  "margin-left": "40px"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onConfiguration(
                                                      workflowIndex
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.rulesLabelName(
                                                      item,
                                                      false
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-delete",
                                              staticStyle: {
                                                "align-self": "center",
                                                color: "red",
                                                "margin-right": "10px"
                                              },
                                              on: {
                                                "!click": function($event) {
                                                  return _vm.removeBranchProcess(
                                                    workflowIndex
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _c(
                                          "draggable",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "flex-wrap": "wrap",
                                              "padding-left": "28px",
                                              "margin-bottom": "15px"
                                            },
                                            attrs: {
                                              options: {
                                                handle: ".drag-handle"
                                              }
                                            },
                                            on: { end: _vm.toEnd },
                                            model: {
                                              value: item.nodes,
                                              callback: function($$v) {
                                                _vm.$set(item, "nodes", $$v)
                                              },
                                              expression: "item.nodes"
                                            }
                                          },
                                          _vm._l(item.nodes, function(
                                            card,
                                            index
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticStyle: {
                                                  display: "flex",
                                                  "flex-wrap": "wrap",
                                                  "align-self": "center",
                                                  "margin-top": "15px"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    class:
                                                      "record-card " +
                                                      (item.priority ===
                                                        _vm.choosePriority &&
                                                      index === _vm.chooseIndex
                                                        ? "is-active"
                                                        : "") +
                                                      (card.isAdd
                                                        ? " no-drag"
                                                        : ""),
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.chooseNode(
                                                          card,
                                                          item.priority,
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    !card.isAdd
                                                      ? _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                margin: "10px",
                                                                display: "flex"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "drag-handle",
                                                                  staticStyle: {
                                                                    "padding-right":
                                                                      "10px"
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-rank",
                                                                    staticStyle: {
                                                                      "margin-right":
                                                                        "10px"
                                                                    }
                                                                  }),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "node-name"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          card.nodeName
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-delete",
                                                                on: {
                                                                  "!click": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeNode(
                                                                      workflowIndex,
                                                                      index
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "card-content",
                                                              attrs: {
                                                                title: _vm.showApproval(
                                                                  card,
                                                                  true
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.showApproval(
                                                                      card
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "card-content",
                                                              staticStyle: {
                                                                "margin-top":
                                                                  "10px"
                                                              },
                                                              attrs: {
                                                                title: _vm.showNotifier(
                                                                  card,
                                                                  true
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.showNotifier(
                                                                      card
                                                                    ) === ""
                                                                      ? ""
                                                                      : _vm.$t(
                                                                          "CargoMsg.Cargo_CcPerson"
                                                                        ) +
                                                                          "：" +
                                                                          _vm.showNotifier(
                                                                            card
                                                                          )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      : _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                height: "100%",
                                                                "margin-top":
                                                                  "10%",
                                                                "text-align":
                                                                  "center"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    cursor:
                                                                      "pointer",
                                                                    "font-size":
                                                                      "40px",
                                                                    color:
                                                                      "rgba(159, 180, 225)"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.addNode(
                                                                        workflowIndex,
                                                                        item.priority
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("+")]
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                  ]
                                                ),
                                                index < item.nodes.length - 1
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          position: "relative"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "arrow-container"
                                                          },
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "arrow-line"
                                                            }),
                                                            _c("div", {
                                                              staticClass:
                                                                "arrow-head"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "background-color": "rgba(244, 249, 255)",
                                  "margin-left": "10px",
                                  "margin-top": "10px"
                                },
                                attrs: {
                                  disabled: _vm.addBranchProcessDisable,
                                  type: "text"
                                },
                                on: { click: _vm.addBranchProcess }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_AddBranchProcess")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            2
          ),
          _vm.chooseUserDialog.visible
            ? _c("choose-user-dialog", {
                attrs: {
                  visible: _vm.chooseUserDialog.visible,
                  value: _vm.node.actorId
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.chooseUserDialog, "visible", $event)
                  },
                  close: function($event) {
                    _vm.chooseUserDialog.visible = false
                  },
                  change: function(p) {
                    _vm.node.actorId = p
                    _vm.chooseUserDialog.visible = false
                  }
                }
              })
            : _vm._e(),
          _vm.chooseRoleDialog.visible
            ? _c("choose-role-dialog", {
                attrs: {
                  visible: _vm.chooseRoleDialog.visible,
                  "row-data": _vm.chooseRoleDialog.officeDeptRowData,
                  value: _vm.node.actorId
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.chooseRoleDialog, "visible", $event)
                  },
                  close: function($event) {
                    _vm.chooseRoleDialog.visible = false
                  },
                  change: function(p) {
                    _vm.node.actorId = p
                  }
                }
              })
            : _vm._e(),
          _vm.castConfigurationDialog.visible
            ? _c("choose-cast-dialog", {
                attrs: {
                  visible: _vm.castConfigurationDialog.visible,
                  values: _vm.node.actorId
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.castConfigurationDialog,
                      "visible",
                      $event
                    )
                  },
                  close: function($event) {
                    _vm.castConfigurationDialog.visible = false
                  },
                  change: function(p) {
                    _vm.node.actorId = p
                    _vm.castConfigurationDialog.visible = false
                  }
                }
              })
            : _vm._e(),
          _vm.chooseNotifierUserDialog.visible
            ? _c("choose-notifier-user-dialog", {
                attrs: {
                  title: _vm.$t("CargoMsg.Cargo_SelectCcTo"),
                  visible: _vm.chooseNotifierUserDialog.visible,
                  value: _vm.node.notifierId
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.chooseNotifierUserDialog,
                      "visible",
                      $event
                    )
                  },
                  close: function($event) {
                    _vm.chooseNotifierUserDialog.visible = false
                  },
                  change: function(p) {
                    _vm.node.notifierId = p
                    _vm.chooseUserDialog.visible = false
                  }
                }
              })
            : _vm._e(),
          _vm.chooseNotifierRoleDialog.visible
            ? _c("choose-notifier-role-dialog", {
                attrs: {
                  visible: _vm.chooseNotifierRoleDialog.visible,
                  "row-data": _vm.chooseNotifierRoleDialog.officeDeptRowData,
                  value: _vm.node.notifierId
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.chooseNotifierRoleDialog,
                      "visible",
                      $event
                    )
                  },
                  close: function($event) {
                    _vm.chooseNotifierRoleDialog.visible = false
                  },
                  change: function(p) {
                    _vm.node.notifierId = p
                  }
                }
              })
            : _vm._e(),
          _vm.chooseNotifierCastDialog.visible
            ? _c("choose-notifier-cast-dialog", {
                attrs: {
                  visible: _vm.chooseNotifierCastDialog.visible,
                  values: _vm.node.notifierId
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.chooseNotifierCastDialog,
                      "visible",
                      $event
                    )
                  },
                  close: function($event) {
                    _vm.chooseNotifierCastDialog.visible = false
                  },
                  change: function(p) {
                    _vm.node.notifierId = p
                    _vm.chooseNotifierCastDialog.visible = false
                  }
                }
              })
            : _vm._e(),
          _vm.ruleConfigurationDialog.visible
            ? _c("rule-configuration-dialog", {
                attrs: {
                  visible: _vm.ruleConfigurationDialog.visible,
                  rules: _vm.rules,
                  workflow: _vm.form.workflows[_vm.chooseWorkflowIndexRule],
                  value: _vm.node.actorId,
                  "office-ids": _vm.form.officeIds
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.ruleConfigurationDialog,
                      "visible",
                      $event
                    )
                  },
                  close: function($event) {
                    _vm.ruleConfigurationDialog.visible = false
                  },
                  change: function(p) {
                    _vm.form.workflows[_vm.chooseWorkflowIndexRule] = p
                  }
                }
              })
            : _vm._e(),
          _vm.bindApprovalTemplateDialog.visible
            ? _c("bind-approval-template-dialog", {
                attrs: { visible: _vm.bindApprovalTemplateDialog.visible },
                on: {
                  close: function($event) {
                    _vm.bindApprovalTemplateDialog.visible = false
                  },
                  choose: _vm.chooseTemplate
                }
              })
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }